/* El Quarto — acuse de "Agregar al carrito", compartido por catalogos y fichas.
   Todo pasa DENTRO del boton: un trazo de acento sustituye al borde de 1px y le
   da la vuelta desde la mitad del lateral izquierdo a 540px/s (la unica
   velocidad de la pagina: el perimetro define el tiempo). Al cerrar el
   recorrido la palabra entra en registro y el mismo trazo engorda y se apaga
   — el acuse no es un objeto nuevo, es el trazo que acaba de dar la vuelta.
   Cero peso en reposo: el SVG se crea al click y se retira al terminar.

   window.eqTrazoAgregar(boton, label, textoHecho, alCerrar) -> true si corrio
   alCerrar: se llama cuando el trazo cierra el recorrido, en el mismo cuadro en
   que entra "Sumado". Ahi sube el contador de la bolsa, no antes. */
(function () {
  if (window.eqTrazoAgregar) return;
  var NS = 'http://www.w3.org/2000/svg';

  window.eqTrazoAgregar = function (b, label, textoHecho, alCerrar) {
    if (!b || !label || b.dataset.eqBusy) return false;
    b.dataset.eqBusy = '1';

    var antes = label.textContent;
    var hecho = textoHecho || 'Sumado';
    var lento = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var cs = getComputedStyle(b);
    var acento = (cs.getPropertyValue('--eq-accent') || '').trim() || '#ec673d';
    var caja = b.getBoundingClientRect();
    var bw = parseFloat(cs.borderTopWidth) || 1; // el borde a sustituir
    var W = Math.max(40, caja.width) - bw;
    var H = Math.max(24, caja.height) - bw;
    var r = H / 2;
    // la palabra cambia de largo: se fija el ancho MIENTRAS corre el acuse y se
    // suelta al terminar, asi el boton no se mueve y sigue siendo fluido
    var minAntes = b.style.minWidth;
    b.style.minWidth = caja.width.toFixed(2) + 'px';

    var svg = b.querySelector('svg[data-eq-aroadd]');
    if (svg && svg.parentNode) svg.parentNode.removeChild(svg);
    svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('data-eq-aroadd', '1');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('width', String(caja.width));
    svg.setAttribute('height', String(caja.height));
    // un absoluto se posiciona contra la caja de PADDING: hay que sacarlo el
    // ancho del borde para que el trazo caiga SOBRE el borde, no por dentro
    svg.style.cssText = 'position:absolute;left:' + (-bw) + 'px;top:' + (-bw) +
      'px;overflow:visible;pointer-events:none';

    var aro = document.createElementNS(NS, 'path');
    var x = bw / 2, y = bw / 2, cy = y + r;
    aro.setAttribute('d',
      'M ' + x + ' ' + cy +
      ' A ' + r + ' ' + r + ' 0 0 1 ' + (x + r) + ' ' + y +
      ' L ' + (x + W - r) + ' ' + y +
      ' A ' + r + ' ' + r + ' 0 0 1 ' + (x + W) + ' ' + cy +
      ' A ' + r + ' ' + r + ' 0 0 1 ' + (x + W - r) + ' ' + (y + H) +
      ' L ' + (x + r) + ' ' + (y + H) +
      ' A ' + r + ' ' + r + ' 0 0 1 ' + x + ' ' + cy + ' Z');
    aro.setAttribute('fill', 'none');
    aro.setAttribute('stroke', acento);
    var grosor = Math.max(2, bw * 2.2);
    aro.setAttribute('stroke-width', String(grosor));
    svg.appendChild(aro);
    if (!b.style.position && getComputedStyle(b).position === 'static') b.style.position = 'relative';
    b.appendChild(svg);

    var perim = aro.getTotalLength();
    var corrida = lento ? 0 : perim / 0.54;
    // cuando cierra la vuelta: el aviso de "sumado" cae en ese momento, no antes
    window.__eqTrazoFin = performance.now() + corrida;
    aro.setAttribute('stroke-dasharray', String(perim));
    aro.setAttribute('stroke-dashoffset', lento ? '0' : String(perim));

    if (!lento) {
      aro.animate([{ strokeDashoffset: perim }, { strokeDashoffset: 0 }],
        { duration: corrida, easing: 'linear', fill: 'forwards' });
    }

    var t1 = setTimeout(function () {
      label.textContent = hecho;
      if (alCerrar) { try { alCerrar(); } catch (e) {} }
      if (lento) return;
      label.animate(
        [{ clipPath: 'inset(100% -4px 0 -4px)', transform: 'translateY(3px)' },
         { clipPath: 'inset(-4px)', transform: 'translateY(0)' }],
        { duration: 240, easing: 'cubic-bezier(.65,0,.35,1)', fill: 'none' });
      aro.animate(
        [{ strokeWidth: grosor, opacity: 1, offset: 0 },
         { strokeWidth: grosor * 2.6, opacity: 1, offset: 0.26 },
         { strokeWidth: grosor * 2.6, opacity: 0, offset: 1 }],
        { duration: 420, easing: 'cubic-bezier(.65,0,.35,1)', fill: 'forwards' });
    }, corrida);

    var t2 = setTimeout(function () {
      label.textContent = antes;
      b.style.minWidth = minAntes;
      if (svg.parentNode) svg.parentNode.removeChild(svg);
      delete b.dataset.eqBusy;
      b.__eqTrazo = null;
    }, corrida + 1000);

    // si el alta falla, el acuse se CORTA: sin esto el trazo seguia y a los
    // ~700ms escribia "Sumado" encima del error (el boton mentia)
    b.__eqTrazo = function () {
      clearTimeout(t1); clearTimeout(t2);
      aro.getAnimations().forEach(function (a) { a.cancel(); });
      label.getAnimations().forEach(function (a) { a.cancel(); });
      if (svg.parentNode) svg.parentNode.removeChild(svg);
      label.textContent = antes;
      b.style.minWidth = minAntes;
      b.__eqTrazo = null;
      return antes;
    };

    return true;
  };

  // corta un acuse en curso (lo usa eq-cart.js cuando el servidor rechaza el alta)
  window.eqTrazoAbortar = function (b) { return b && b.__eqTrazo ? b.__eqTrazo() : null; };
})();
